import styled from "@emotion/styled"
import Describe from "../components/Describe/Describe"
import image from '../assets/image.webp'
import { CustomizationBottomDescribeData, CustomizationTopDescribeData } from '../components/staticDescribeData'

export default function Customization() {
    return (
        <div style={{ marginTop: 58.4, height: 789.6 }}>
            <div className="top">
                <TitleSpan>精品音色定制</TitleSpan>
                <DescribeSpan>精品音色定制需要使用一定量的高质量训练音频，产出具有行业竞争力的TTS音色模型。</DescribeSpan>
                <DescribeDiv>
                    {CustomizationTopDescribeData?.map((item, index) => {
                        return < Describe data={item} index={index} />
                    })}
                </DescribeDiv>
            </div>
            <div className="top">
                <TitleSpan >交付和部署形式</TitleSpan>
                <DescribeDiv>
                    {CustomizationBottomDescribeData?.map((item, index) => {
                        return < Describe data={item} index={index} />
                    })}
                </DescribeDiv>
            </div>
            <div className="top">
                <TitleSpan >提供专业服务</TitleSpan>
                <DescribeSpan>提供1对1咨询和技术服务，高品质声音录制，标准，精调训练，为您提供专业服务。</DescribeSpan>
            </div>
            <div className="bottom">
                <img style={{ marginTop: 30, marginBottom: '-10px' }} src={image} alt="" />
                <span className="email">
                    可将您公司的信息发送至该邮箱 <span style={{ color: '#ff671d' }}>voice@mthreads.com</span> 后续会有专员与您对接。
                </span>
            </div>

        </div>
    )
}

const DescribeDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    margin-top: 48px; 
    height: 198px;
`
const TitleSpan = styled.span`
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0px;
    color: #222222;
`

const DescribeSpan = styled.span`
    font-size: 12px;
    font-weight: normal;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0px;
    color: #999999;
    margin-top: 10px;
`